import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  alternativeOffersCphOsl,
  alternativeOffersOslLhr,
  orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip,
  orderWithOpenJawBothBoundDisrupted,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const openJawBothBoundDisruptedMock: MockMap = {
  retrieveOrder: [createMockData(orderWithOpenJawBothBoundDisrupted, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip, [], [orderNotEligibleForRefundWarning])],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl), createMockData(alternativeOffersOslLhr)]
};
